// Footer for the Academy page, the same shape as the one on
// policenarratives.ai: slate band, light logo on the left, four quiet links
// on the right. Always dark (it is a brand band, not a themed surface), so
// the light-on-dark logo variant is used directly instead of <Logo>.
import { ReactComponent as LogoOnDark } from "../../police-narratives-ai-dark-mode.svg";

const LINKS: { label: string; href: string }[] = [
  { label: "Security", href: "https://policenarratives.ai/security" },
  { label: "Terms", href: "https://policenarratives.ai/terms-of-use" },
  { label: "Privacy", href: "/privacy-policy" },
  { label: "Contact", href: "mailto:support@policenarratives.ai" },
];

const AcademyFooter: React.FC = () => (
  <footer className="py-10 bg-slate-800 text-white mt-16">
    <div className="max-w-[1440px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
      <LogoOnDark className="h-7 w-auto" title="Police Narratives AI" />
      <div className="flex items-center gap-8 text-sm">
        {LINKS.map((l) => (
          <a key={l.label} href={l.href} className="text-white hover:text-slate-200 transition-colors" {...(l.href.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})}>
            {l.label}
          </a>
        ))}
      </div>
    </div>
  </footer>
);

export default AcademyFooter;
